/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservationInvoiceIsdocPathParameters } from 'api/actions/get-reservation-invoice-isdoc/get-reservation-invoice-isdoc-path-parameters';
import { GetReservationInvoiceIsdocResponse } from 'api/actions/get-reservation-invoice-isdoc/get-reservation-invoice-isdoc-response';

type GetReservationInvoiceIsdocQueryParameters = Record<string, any>;

/**
 * The path of the GetReservationInvoiceIsdoc action.
 */
export const getReservationInvoiceIsdocActionPath = new SweetPath<keyof GetReservationInvoiceIsdocPathParameters>(
  '/reservations/{reservationId}/invoice/isdoc',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetReservationInvoiceIsdoc actions.
 */
export default function createGetReservationInvoiceIsdocAction(axios: AxiosInstance) {
  return function getReservationInvoiceIsdocAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetReservationInvoiceIsdocPathParameters;
    query?: GetReservationInvoiceIsdocQueryParameters;
  }) {
    const path = getReservationInvoiceIsdocActionPath.insert(parameters);

    return axios.get<GetReservationInvoiceIsdocResponse, GetReservationInvoiceIsdocResponse>(path, {
      params: query,
      headers,
    });
  };
}
